var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86458 11.0657C7.14445 11.0657 5.75 9.6615 5.75 7.92933C5.75 6.19717 7.14445 4.79297 8.86458 4.79297C10.5847 4.79297 11.9792 6.19717 11.9792 7.92933C11.9792 9.6615 10.5847 11.0657 8.86458 11.0657Z",
    fill: "#DEDAD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91702 18.4939C2.22657 14.4918 5.32011 12.457 9.0907 12.457C12.9143 12.457 16.0558 14.38 16.2898 18.4945C16.2992 18.6584 16.2898 19.1654 15.6899 19.1654C12.7306 19.1654 8.33312 19.1654 2.4975 19.1654C2.29721 19.1654 1.90016 18.7119 1.91702 18.4939Z",
    fill: "#B5B5C3"
  })));
}

export default SvgPerson;